// import Map, {Marker, Source, Layer} from 'react-map-gl'
// import maplibregl from 'maplibre-gl'
// import 'maplibre-gl/dist/maplibre-gl.css'
// import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
// import {useEffect, useRef, useState} from 'react'
// import {KTIcon} from '../../../_metronic/helpers'
// import './index.css'

// export default function MapComponent({updateItemId}) {
//   const mapRef = useRef(null)
//   const fileInputRef = useRef(null)
//   const [searchQuery, setSearchQuery] = useState('')
//   const [showSuggestions, setShowSuggestions] = useState(false)
//   const [suggestions, setSuggestions] = useState([])
//   const [searchResult, setSearchResult] = useState(null)
//   const [selectedLocation, setSelectedLocation] = useState(null)
//   const [kmlData, setKmlData] = useState(null)
//   const [showGeofenceModal, setShowGeofenceModal] = useState(false)
//   const [geofences, setGeofences] = useState([])
//   const [drawingMode, setDrawingMode] = useState(null)
//   const [currentGeofence, setCurrentGeofence] = useState(null)
//   const [geofenceName, setGeofenceName] = useState('')
//   const [geofenceRadius, setGeofenceRadius] = useState(500)
//   const [polygonPoints, setPolygonPoints] = useState([])
//   // const [locationRestriction, setLocationRestriction] = useState('none') // 'none', 'inside', 'outside'
//   // const [showRestrictionSettings, setShowRestrictionSettings] = useState(false)

//   const accessToken =
//     'pk.eyJ1IjoiZ2FuZXN3YXJhcmFvIiwiYSI6ImNsdHBpeXJtZjA2eWkya28xcW8xbjg4dXcifQ.2NgizzxlIv7hziFTq6JmgQ'

//   const handleSearch = async () => {
//     if (!searchQuery.trim()) return
//     try {
//       const response = await fetch(
//         `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
//           searchQuery
//         )}.json?access_token=${accessToken}`
//       )
//       const data = await response.json()
//       if (data.features && data.features.length > 0) {
//         const [longitude, latitude] = data.features[0].center

//         if (!isLocationAllowed(longitude, latitude)) {
//           alert(`Location selection is restricted ${locationRestriction} geofences`)
//           return
//         }

//         setSearchResult({longitude, latitude})
//         updateItemId(data.features[0])
//         mapRef.current.getMap().flyTo({center: [longitude, latitude], zoom: 12})
//         setShowSuggestions(false)
//       } else {
//         console.error('No results found')
//       }
//     } catch (error) {
//       console.error('Error fetching coordinates:', error)
//     }
//   }

//   const isPointInPolygon = (point, polygon) => {
//     const x = point[0],
//       y = point[1]
//     let inside = false

//     for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
//       const xi = polygon[i][0],
//         yi = polygon[i][1]
//       const xj = polygon[j][0],
//         yj = polygon[j][1]

//       const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
//       if (intersect) inside = !inside
//     }

//     return inside
//   }

//   const isPointInCircle = (point, center, radiusInMeters) => {
//     const [x1, y1] = point
//     const [x2, y2] = center

//     const dx = (x1 - x2) * 111320 * Math.cos((y2 * Math.PI) / 180)
//     const dy = (y1 - y2) * 110574
//     const distance = Math.sqrt(dx * dx + dy * dy)

//     return distance <= radiusInMeters
//   }

//   const isLocationAllowed = (lng, lat) => {
//     if (locationRestriction === 'none' || geofences.length === 0) {
//       return true
//     }

//     const point = [lng, lat]
//     const isInsideAnyGeofence = geofences.some((gf) => {
//       if (gf.type === 'circle') {
//         return isPointInCircle(point, gf.center, gf.radius)
//       } else if (gf.type === 'polygon') {
//         return isPointInPolygon(point, gf.coordinates)
//       }
//       return false
//     })

//     if (locationRestriction === 'inside') {
//       return isInsideAnyGeofence
//     } else if (locationRestriction === 'outside') {
//       return !isInsideAnyGeofence
//     }

//     return true
//   }

//   const handleMapClick = async (event) => {
//     const {lngLat} = event

//     // Handle polygon drawing
//     if (drawingMode === 'polygon') {
//       const newPoint = [lngLat.lng, lngLat.lat]
//       setPolygonPoints([...polygonPoints, newPoint])
//       return
//     }

//     // Handle circle drawing
//     if (drawingMode === 'circle') {
//       setCurrentGeofence({
//         type: 'circle',
//         center: [lngLat.lng, lngLat.lat],
//         radius: geofenceRadius,
//       })
//       setShowGeofenceModal(true)
//       setDrawingMode(null)
//       return
//     }

//     // Check location restriction
//     if (!isLocationAllowed(lngLat.lng, lngLat.lat)) {
//       alert(`Location selection is restricted ${locationRestriction} geofences`)
//       return
//     }

//     try {
//       const response = await fetch(
//         `https://api.mapbox.com/geocoding/v5/mapbox.places/${lngLat.lng},${lngLat.lat}.json?access_token=${accessToken}`
//       )
//       const data = await response.json()
//       if (data.features && data.features.length > 0) {
//         const [longitude, latitude] = data.features[0].center
//         const locationData = {
//           longitude,
//           latitude,
//           placeName: data.features[0].place_name,
//           address: data.features[0].properties?.address || '',
//         }
//         setSelectedLocation(locationData)
//         setSearchResult({longitude, latitude})
//         updateItemId(data.features[0])
//       } else {
//         setSelectedLocation({
//           longitude: lngLat.lng,
//           latitude: lngLat.lat,
//           placeName: `${lngLat.lat.toFixed(6)}, ${lngLat.lng.toFixed(6)}`,
//           address: '',
//         })
//         setSearchResult({longitude: lngLat.lng, latitude: lngLat.lat})
//       }
//     } catch (error) {
//       console.error('Error fetching location details:', error)
//     }
//   }

//   const finishPolygonDrawing = () => {
//     if (polygonPoints.length < 3) {
//       alert('Please add at least 3 points to create a polygon')
//       return
//     }

//     setCurrentGeofence({
//       type: 'polygon',
//       coordinates: [...polygonPoints, polygonPoints[0]], // Close the polygon
//     })
//     setShowGeofenceModal(true)
//     setDrawingMode(null)
//   }

//   const cancelPolygonDrawing = () => {
//     setPolygonPoints([])
//     setDrawingMode(null)
//   }

//   const createCircleGeoJSON = (center, radiusInMeters) => {
//     const points = 64
//     const coords = []
//     const distanceX = radiusInMeters / (111320 * Math.cos((center[1] * Math.PI) / 180))
//     const distanceY = radiusInMeters / 110574

//     for (let i = 0; i < points; i++) {
//       const theta = (i / points) * (2 * Math.PI)
//       const x = distanceX * Math.cos(theta)
//       const y = distanceY * Math.sin(theta)
//       coords.push([center[0] + x, center[1] + y])
//     }
//     coords.push(coords[0])

//     return {
//       type: 'Feature',
//       properties: {},
//       geometry: {
//         type: 'Polygon',
//         coordinates: [coords],
//       },
//     }
//   }

//   const createPolygonGeoJSON = (coordinates) => {
//     return {
//       type: 'Feature',
//       properties: {},
//       geometry: {
//         type: 'Polygon',
//         coordinates: [coordinates],
//       },
//     }
//   }

//   const saveGeofence = () => {
//     if (!geofenceName.trim() || !currentGeofence) {
//       alert('Please enter a geofence name')
//       return
//     }

//     const newGeofence = {
//       id: Date.now(),
//       name: geofenceName,
//       type: currentGeofence.type,
//       ...(currentGeofence.type === 'circle'
//         ? {
//             center: currentGeofence.center,
//             radius: currentGeofence.radius,
//             geoJSON: createCircleGeoJSON(currentGeofence.center, currentGeofence.radius),
//           }
//         : {
//             coordinates: currentGeofence.coordinates,
//             geoJSON: createPolygonGeoJSON(currentGeofence.coordinates),
//           }),
//     }

//     setGeofences([...geofences, newGeofence])
//     setShowGeofenceModal(false)
//     setGeofenceName('')
//     setCurrentGeofence(null)
//     setPolygonPoints([])
//   }

//   const deleteGeofence = (id) => {
//     setGeofences(geofences.filter((gf) => gf.id !== id))
//   }

//   const parseKMLToGeoJSON = (kmlText) => {
//     const parser = new DOMParser()
//     const xmlDoc = parser.parseFromString(kmlText, 'text/xml')

//     const features = []
//     const placemarks = xmlDoc.getElementsByTagName('Placemark')

//     for (let i = 0; i < placemarks.length; i++) {
//       const placemark = placemarks[i]
//       const name = placemark.getElementsByTagName('name')[0]?.textContent || `Feature ${i + 1}`

//       const point = placemark.getElementsByTagName('Point')[0]
//       if (point) {
//         const coordinates = point.getElementsByTagName('coordinates')[0]?.textContent.trim()
//         if (coordinates) {
//           const [lng, lat] = coordinates.split(',').map(Number)
//           features.push({
//             type: 'Feature',
//             properties: {name},
//             geometry: {
//               type: 'Point',
//               coordinates: [lng, lat],
//             },
//           })
//         }
//       }

//       const lineString = placemark.getElementsByTagName('LineString')[0]
//       if (lineString) {
//         const coordinates = lineString.getElementsByTagName('coordinates')[0]?.textContent.trim()
//         if (coordinates) {
//           const coords = coordinates.split(/\s+/).map((coord) => {
//             const [lng, lat] = coord.split(',').map(Number)
//             return [lng, lat]
//           })
//           features.push({
//             type: 'Feature',
//             properties: {name},
//             geometry: {
//               type: 'LineString',
//               coordinates: coords,
//             },
//           })
//         }
//       }

//       const polygon = placemark.getElementsByTagName('Polygon')[0]
//       if (polygon) {
//         const outerBoundary = polygon.getElementsByTagName('outerBoundaryIs')[0]
//         if (outerBoundary) {
//           const coordinates = outerBoundary
//             .getElementsByTagName('coordinates')[0]
//             ?.textContent.trim()
//           if (coordinates) {
//             const coords = coordinates.split(/\s+/).map((coord) => {
//               const [lng, lat] = coord.split(',').map(Number)
//               return [lng, lat]
//             })
//             features.push({
//               type: 'Feature',
//               properties: {name},
//               geometry: {
//                 type: 'Polygon',
//                 coordinates: [coords],
//               },
//             })
//           }
//         }
//       }
//     }

//     return {
//       type: 'FeatureCollection',
//       features,
//     }
//   }

//   const handleKMLUpload = (event) => {
//     const file = event.target.files[0]
//     if (!file) return

//     const reader = new FileReader()
//     reader.onload = (e) => {
//       try {
//         const kmlText = e.target.result
//         const geoJSON = parseKMLToGeoJSON(kmlText)

//         if (geoJSON.features.length > 0) {
//           setKmlData(geoJSON)

//           const coordinates = []
//           geoJSON.features.forEach((feature) => {
//             if (feature.geometry.type === 'Point') {
//               coordinates.push(feature.geometry.coordinates)
//             } else if (feature.geometry.type === 'LineString') {
//               coordinates.push(...feature.geometry.coordinates)
//             } else if (feature.geometry.type === 'Polygon') {
//               coordinates.push(...feature.geometry.coordinates[0])
//             }
//           })

//           if (coordinates.length > 0) {
//             const lngs = coordinates.map((c) => c[0])
//             const lats = coordinates.map((c) => c[1])
//             const bounds = [
//               [Math.min(...lngs), Math.min(...lats)],
//               [Math.max(...lngs), Math.max(...lats)],
//             ]
//             mapRef.current.getMap().fitBounds(bounds, {padding: 50})
//           }
//         } else {
//           alert('No valid features found in KML file')
//         }
//       } catch (error) {
//         console.error('Error parsing KML:', error)
//         alert('Error parsing KML file. Please ensure it is a valid KML file.')
//       }
//     }
//     reader.readAsText(file)
//   }

//   useEffect(() => {
//     const fetchSuggestions = async () => {
//       if (!searchQuery.trim()) {
//         setSuggestions([])
//         return
//       }
//       try {
//         const response = await fetch(
//           `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
//             searchQuery
//           )}.json?access_token=${accessToken}`
//         )
//         const data = await response.json()
//         setSuggestions(data.features ? data.features.map((f) => f.place_name) : [])
//       } catch (error) {
//         console.error('Error fetching suggestions:', error)
//         setSuggestions([])
//       }
//     }

//     fetchSuggestions()
//   }, [searchQuery])

//   const temporaryPolygonGeoJSON =
//     polygonPoints.length >= 2
//       ? {
//           type: 'FeatureCollection',
//           features: [
//             {
//               type: 'Feature',
//               geometry: {
//                 type: 'LineString',
//                 coordinates: polygonPoints,
//               },
//             },
//           ],
//         }
//       : null

//   const temporaryPointsGeoJSON =
//     polygonPoints.length > 0
//       ? {
//           type: 'FeatureCollection',
//           features: polygonPoints.map((point, i) => ({
//             type: 'Feature',
//             properties: {index: i},
//             geometry: {
//               type: 'Point',
//               coordinates: point,
//             },
//           })),
//         }
//       : null

//   return (
//     <div className='map-container'>
//       {/* Left Sidebar */}
//       <div className='card map-sidebar'>
//         {/* Search Section */}
//         <div style={{padding: '20px', borderBottom: '1px solid #e5e7eb'}}>
//           <h4 className='mb-3 fw-semibold'>Search Location</h4>
//           <div className='position-relative'>
//             <KTIcon
//               iconName='magnifier'
//               className='fs-3 position-absolute ms-3 mt-4 text-gray-600'
//             />
//             <input
//               type='search'
//               value={searchQuery}
//               onChange={(e) => {
//                 setSearchQuery(e.target.value)
//                 setShowSuggestions(true)
//               }}
//               placeholder='Search location...'
//               className='form-control form-control-lg ps-10'
//               style={{borderRadius: '8px'}}
//             />
//           </div>

//           {showSuggestions && suggestions.length > 0 && (
//             <div
//               className='card mt-2 shadow-sm'
//               style={{
//                 maxHeight: '200px',
//                 overflowY: 'auto',
//                 borderRadius: '8px',
//               }}
//             >
//               {suggestions.map((name, index) => (
//                 <div
//                   key={index}
//                   onClick={() => {
//                     setSearchQuery(name)
//                     handleSearch()
//                   }}
//                   style={{
//                     padding: '10px 15px',
//                     cursor: 'pointer',
//                     borderBottom: index < suggestions.length - 1 ? '1px solid #f1f1f1' : 'none',
//                   }}
//                   className='text-hover-primary'
//                 >
//                   <small>{name}</small>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Controls Section */}
//         <div style={{padding: '20px', borderBottom: '1px solid #e5e7eb'}}>
//           <h4 className='mb-3 fw-semibold'>Drawing Tools</h4>
//           <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
//             <input
//               ref={fileInputRef}
//               type='file'
//               accept='.kml'
//               onChange={handleKMLUpload}
//               style={{display: 'none'}}
//             />
//             <button
//               onClick={() => fileInputRef.current?.click()}
//               className='btn btn-light w-100 d-flex align-items-center justify-content-start gap-2'
//               style={{borderRadius: '8px'}}
//             >
//               <KTIcon iconName='file-up' className='fs-3' />
//               <span>Upload KML File</span>
//             </button>
//             <button
//               onClick={() => {
//                 setDrawingMode('circle')
//                 alert('Click on the map to place a circular geofence')
//               }}
//               className={`btn ${
//                 drawingMode === 'circle' ? 'btn-primary' : 'btn-light'
//               } w-100 d-flex align-items-center justify-content-start gap-2`}
//               style={{borderRadius: '8px'}}
//             >
//               <KTIcon iconName='plus-circle' className='fs-3' />
//               <span>Draw Circle</span>
//             </button>
//             <button
//               onClick={() => {
//                 setDrawingMode('polygon')
//                 setPolygonPoints([])
//                 alert('Click on the map to add polygon points. Use Finish button when done.')
//               }}
//               className={`btn ${
//                 drawingMode === 'polygon' ? 'btn-primary' : 'btn-light'
//               } w-100 d-flex align-items-center justify-content-start gap-2`}
//               style={{borderRadius: '8px'}}
//             >
//               <KTIcon iconName='abstract-26' className='fs-3' />
//               <span>Draw Polygon</span>
//             </button>
//           </div>
//         </div>

//         {/* Polygon Drawing Controls */}
//         {drawingMode === 'polygon' && (
//           <div style={{padding: '20px', background: '#fef3c7', borderBottom: '1px solid #fde047'}}>
//             <h6 className='mb-2 fw-bold text-warning'>Drawing Mode Active</h6>
//             <p className='text-muted small mb-3'>
//               Points: {polygonPoints.length}
//               {polygonPoints.length < 3 && <span className='text-danger'> (min 3 required)</span>}
//             </p>
//             <div className='d-flex gap-2'>
//               <button
//                 onClick={finishPolygonDrawing}
//                 className='btn btn-sm btn-success flex-grow-1'
//                 disabled={polygonPoints.length < 3}
//               >
//                 <KTIcon iconName='check' className='fs-4' />
//                 Finish
//               </button>
//               <button onClick={cancelPolygonDrawing} className='btn btn-sm btn-light'>
//                 <KTIcon iconName='cross' className='fs-4' />
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Location Restrictions */}
//         <div style={{padding: '20px', borderBottom: '1px solid #e5e7eb'}}>
//           <h4 className='mb-3 fw-semibold'>Location Restrictions</h4>
//           <div className='form-check mb-2'>
//             <input
//               className='form-check-input'
//               type='radio'
//               name='restriction'
//               id='restriction-none'
//               checked={locationRestriction === 'none'}
//               onChange={() => setLocationRestriction('none')}
//             />
//             <label className='form-check-label' htmlFor='restriction-none'>
//               <small>No Restrictions</small>
//             </label>
//           </div>
//           <div className='form-check mb-2'>
//             <input
//               className='form-check-input'
//               type='radio'
//               name='restriction'
//               id='restriction-inside'
//               checked={locationRestriction === 'inside'}
//               onChange={() => setLocationRestriction('inside')}
//               disabled={geofences.length === 0}
//             />
//             <label className='form-check-label' htmlFor='restriction-inside'>
//               <small>Only Inside Geofences</small>
//             </label>
//           </div>
//           <div className='form-check mb-2'>
//             <input
//               className='form-check-input'
//               type='radio'
//               name='restriction'
//               id='restriction-outside'
//               checked={locationRestriction === 'outside'}
//               onChange={() => setLocationRestriction('outside')}
//               disabled={geofences.length === 0}
//             />
//             <label className='form-check-label' htmlFor='restriction-outside'>
//               <small>Only Outside Geofences</small>
//             </label>
//           </div>
//           {geofences.length === 0 && (
//             <div className='alert alert-light mt-2 mb-0 p-2'>
//               <small className='text-muted'>Create geofences first</small>
//             </div>
//           )}
//         </div>

//         {/* Geofences List */}
//         <div style={{flex: 1, overflowY: 'auto', padding: '20px'}}>
//           <h4 className='mb-3 fw-semibold'>Geofences ({geofences.length})</h4>
//           {geofences.length === 0 ? (
//             <div className='text-center text-muted py-4'>
//               <KTIcon iconName='map' className='fs-2x mb-2' />
//               <p className='small mb-0'>No geofences created yet</p>
//             </div>
//           ) : (
//             <div className='d-flex flex-column gap-2'>
//               {geofences.map((gf) => (
//                 <div
//                   key={gf.id}
//                   className='card shadow-sm'
//                   style={{borderRadius: '8px', border: '1px solid #e5e7eb'}}
//                 >
//                   <div className='card-body p-3'>
//                     <div className='d-flex justify-content-between align-items-start'>
//                       <div className='flex-grow-1'>
//                         <div className='fw-bold mb-1'>{gf.name}</div>
//                         <div className='d-flex align-items-center gap-2 text-muted small'>
//                           <KTIcon
//                             iconName={gf.type === 'circle' ? 'plus-circle' : 'abstract-26'}
//                             className='fs-5'
//                           />
//                           <span>{gf.type === 'circle' ? `${gf.radius}m radius` : 'Polygon'}</span>
//                         </div>
//                       </div>
//                       <button
//                         onClick={() => deleteGeofence(gf.id)}
//                         className='btn btn-sm btn-icon btn-light-danger'
//                         style={{width: '32px', height: '32px'}}
//                       >
//                         <KTIcon iconName='trash' className='fs-5' />
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Map Container */}
//       <div className='map-main'>
//         {/* Selected Location Info - Floating on Map */}
//         {selectedLocation && (
//           <div
//             className='card shadow-lg'
//             style={{
//               position: 'absolute',
//               bottom: '20px',
//               left: '20px',
//               right: '20px',
//               zIndex: 999,
//               maxWidth: '400px',
//               borderRadius: '12px',
//               background: '#fff',
//             }}
//           >
//             <div className='card-body p-4'>
//               <div className='d-flex justify-content-between align-items-start mb-3'>
//                 <h5 className='card-title mb-0 fw-bold'>Selected Location</h5>
//                 <button
//                   onClick={() => setSelectedLocation(null)}
//                   className='btn btn-sm btn-icon btn-light'
//                   style={{width: '32px', height: '32px'}}
//                 >
//                   <KTIcon iconName='cross' className='fs-4' />
//                 </button>
//               </div>
//               <div className='text-gray-700'>
//                 <div className='d-flex align-items-start mb-3 p-3 bg-light rounded'>
//                   <KTIcon iconName='geolocation' className='fs-3 me-3 text-primary' />
//                   <div>
//                     <div className='fw-semibold mb-1'>{selectedLocation.placeName}</div>
//                     {selectedLocation.address && (
//                       <div className='text-muted small'>{selectedLocation.address}</div>
//                     )}
//                   </div>
//                 </div>
//                 <div className='d-flex gap-4'>
//                   <div>
//                     <div className='text-muted small'>Latitude</div>
//                     <div className='fw-semibold'>{selectedLocation.latitude.toFixed(6)}</div>
//                   </div>
//                   <div>
//                     <div className='text-muted small'>Longitude</div>
//                     <div className='fw-semibold'>{selectedLocation.longitude.toFixed(6)}</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Geofence Modal */}
//         {showGeofenceModal && (
//           <div
//             className='modal fade show d-block'
//             tabIndex='-1'
//             style={{background: 'rgba(0,0,0,0.5)', zIndex: 10000}}
//           >
//             <div className='modal-dialog modal-dialog-centered'>
//               <div className='modal-content' style={{borderRadius: '12px'}}>
//                 <div className='modal-header border-0 pb-0'>
//                   <h5 className='modal-title fw-bold'>
//                     Create {currentGeofence?.type === 'circle' ? 'Circular' : 'Polygon'} Geofence
//                   </h5>
//                   <button
//                     type='button'
//                     className='btn-close'
//                     onClick={() => {
//                       setShowGeofenceModal(false)
//                       setCurrentGeofence(null)
//                       setPolygonPoints([])
//                     }}
//                   ></button>
//                 </div>
//                 <div className='modal-body pt-3'>
//                   <div className='mb-4'>
//                     <label className='form-label fw-semibold'>Geofence Name</label>
//                     <input
//                       type='text'
//                       className='form-control form-control-lg'
//                       placeholder='e.g., Office Area, Delivery Zone'
//                       value={geofenceName}
//                       onChange={(e) => setGeofenceName(e.target.value)}
//                       style={{borderRadius: '8px'}}
//                     />
//                   </div>
//                   {currentGeofence?.type === 'circle' && (
//                     <div className='mb-4'>
//                       <label className='form-label fw-semibold'>Radius (meters)</label>
//                       <input
//                         type='number'
//                         className='form-control form-control-lg'
//                         value={geofenceRadius}
//                         onChange={(e) => {
//                           setGeofenceRadius(Number(e.target.value))
//                           if (currentGeofence) {
//                             setCurrentGeofence({
//                               ...currentGeofence,
//                               radius: Number(e.target.value),
//                             })
//                           }
//                         }}
//                         min='50'
//                         max='10000'
//                         style={{borderRadius: '8px'}}
//                       />
//                       <div className='form-text'>Set the radius (50-10000m)</div>
//                     </div>
//                   )}
//                   {currentGeofence && (
//                     <div className='alert alert-light' style={{borderRadius: '8px'}}>
//                       <div className='text-muted small'>
//                         {currentGeofence.type === 'circle' ? (
//                           <div>
//                             <strong>Center:</strong> {currentGeofence.center[1].toFixed(6)},{' '}
//                             {currentGeofence.center[0].toFixed(6)}
//                           </div>
//                         ) : (
//                           <div>
//                             <strong>Polygon:</strong> {currentGeofence.coordinates.length - 1}{' '}
//                             points
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className='modal-footer border-0 pt-0'>
//                   <button
//                     type='button'
//                     className='btn btn-light'
//                     onClick={() => {
//                       setShowGeofenceModal(false)
//                       setCurrentGeofence(null)
//                       setPolygonPoints([])
//                     }}
//                     style={{borderRadius: '8px'}}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type='button'
//                     className='btn btn-primary'
//                     onClick={saveGeofence}
//                     style={{borderRadius: '8px'}}
//                   >
//                     <KTIcon iconName='check' className='fs-4 me-2' />
//                     Create Geofence
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Full Width Map */}
//         <Map
//           ref={mapRef}
//           mapLib={maplibregl}
//           mapStyle='https://api.maptiler.com/maps/streets-v2/style.json?key=LiH20XNxcFiTXyT4fgjM'
//           center={
//             searchResult
//               ? [searchResult.longitude, searchResult.latitude]
//               : [-0.481747846041145, 51.3233379650232]
//           }
//           onClick={handleMapClick}
//           style={{
//             width: '100%',
//             height: '100%',
//             borderRadius: '10px',
//             borderTopRightRadius: '10px',
//             borderBottomRightRadius: '10px',
//             cursor: drawingMode ? 'crosshair' : 'default',
//           }}
//         >
//           {searchResult && (
//             <Marker
//               latitude={searchResult.latitude}
//               longitude={searchResult.longitude}
//               offsetLeft={-15}
//               offsetTop={-15}
//             >
//               <KTIcon iconName='geolocation' className='fs-2 text-danger fw-semibold' />
//             </Marker>
//           )}

//           {/* Render Temporary Polygon Drawing */}
//           {temporaryPointsGeoJSON && (
//             <Source id='temp-points' type='geojson' data={temporaryPointsGeoJSON}>
//               <Layer
//                 id='temp-points-layer'
//                 type='circle'
//                 paint={{
//                   'circle-radius': 6,
//                   'circle-color': '#ef4444',
//                   'circle-stroke-width': 2,
//                   'circle-stroke-color': '#ffffff',
//                 }}
//               />
//             </Source>
//           )}

//           {temporaryPolygonGeoJSON && (
//             <Source id='temp-polygon' type='geojson' data={temporaryPolygonGeoJSON}>
//               <Layer
//                 id='temp-polygon-layer'
//                 type='line'
//                 paint={{
//                   'line-color': '#ef4444',
//                   'line-width': 2,
//                   'line-dasharray': [2, 2],
//                 }}
//               />
//             </Source>
//           )}

//           {/* Render Geofences */}
//           {geofences.map((gf) => (
//             <Source
//               key={`geofence-${gf.id}`}
//               id={`geofence-${gf.id}`}
//               type='geojson'
//               data={gf.geoJSON}
//             >
//               <Layer
//                 id={`geofence-fill-${gf.id}`}
//                 type='fill'
//                 paint={{
//                   'fill-color': '#10b981',
//                   'fill-opacity': 0.2,
//                 }}
//               />
//               <Layer
//                 id={`geofence-outline-${gf.id}`}
//                 type='line'
//                 paint={{
//                   'line-color': '#10b981',
//                   'line-width': 3,
//                 }}
//               />
//             </Source>
//           ))}

//           {/* Render KML Data */}
//           {kmlData && (
//             <>
//               <Source id='kml-source' type='geojson' data={kmlData}>
//                 <Layer
//                   id='kml-points'
//                   type='circle'
//                   filter={['==', ['geometry-type'], 'Point']}
//                   paint={{
//                     'circle-radius': 8,
//                     'circle-color': '#3b82f6',
//                     'circle-stroke-width': 2,
//                     'circle-stroke-color': '#ffffff',
//                   }}
//                 />
//                 <Layer
//                   id='kml-lines'
//                   type='line'
//                   filter={['==', ['geometry-type'], 'LineString']}
//                   paint={{
//                     'line-color': '#3b82f6',
//                     'line-width': 3,
//                   }}
//                 />
//                 <Layer
//                   id='kml-polygons-fill'
//                   type='fill'
//                   filter={['==', ['geometry-type'], 'Polygon']}
//                   paint={{
//                     'fill-color': '#3b82f6',
//                     'fill-opacity': 0.3,
//                   }}
//                 />
//                 <Layer
//                   id='kml-polygons-outline'
//                   type='line'
//                   filter={['==', ['geometry-type'], 'Polygon']}
//                   paint={{
//                     'line-color': '#3b82f6',
//                     'line-width': 2,
//                   }}
//                 />
//               </Source>
//             </>
//           )}
//         </Map>
//       </div>
//     </div>
//   )

//   return (
//     <div style={{position: 'relative', width: '100%', height: '600px'}}>
//       {/* Search Box */}
//       <div
//         style={{
//           position: 'absolute',
//           top: '20px',
//           left: '50%',
//           transform: 'translateX(-50%)',
//           zIndex: 999,
//           width: '320px',
//         }}
//       >
//         <div className='d-flex align-items-center position-relative'>
//           <KTIcon iconName='magnifier' className='fs-3 position-absolute ms-3 text-gray-600' />
//           <input
//             type='search'
//             value={searchQuery}
//             onChange={(e) => {
//               setSearchQuery(e.target.value)
//               setShowSuggestions(true)
//             }}
//             placeholder='Search location...'
//             className='form-control form-control-lg ps-9 shadow-sm'
//             style={{
//               background: 'rgba(255, 255, 255, 0.9)',
//               borderRadius: '8px',
//               border: '1px solid #ddd',
//             }}
//           />
//         </div>

//         {showSuggestions && suggestions.length > 0 && (
//           <div
//             className='card mt-2'
//             style={{
//               position: 'absolute',
//               width: '100%',
//               maxHeight: '200px',
//               overflowY: 'auto',
//               borderRadius: '8px',
//               boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
//               background: '#fff',
//               zIndex: 1000,
//             }}
//           >
//             {suggestions.map((name, index) => (
//               <div
//                 key={index}
//                 onClick={() => {
//                   setSearchQuery(name)
//                   handleSearch()
//                 }}
//                 style={{
//                   padding: '10px',
//                   cursor: 'pointer',
//                   borderBottom: '1px solid #f1f1f1',
//                 }}
//                 className='text-hover-primary'
//               >
//                 {name}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Top Right Controls */}
//       <div
//         style={{
//           position: 'absolute',
//           top: '20px',
//           right: '20px',
//           zIndex: 999,
//           display: 'flex',
//           gap: '10px',
//           flexWrap: 'wrap',
//           maxWidth: '400px',
//           justifyContent: 'flex-end',
//         }}
//       >
//         <input
//           ref={fileInputRef}
//           type='file'
//           accept='.kml'
//           onChange={handleKMLUpload}
//           style={{display: 'none'}}
//         />
//         <button
//           onClick={() => fileInputRef.current?.click()}
//           className='btn btn-light shadow-sm'
//           style={{
//             borderRadius: '8px',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '8px',
//           }}
//         >
//           <KTIcon iconName='file-up' className='fs-3' />
//           KML
//         </button>
//         <button
//           onClick={() => {
//             setDrawingMode('circle')
//             alert('Click on the map to place a circular geofence')
//           }}
//           className={`btn ${drawingMode === 'circle' ? 'btn-primary' : 'btn-light'} shadow-sm`}
//           style={{
//             borderRadius: '8px',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '8px',
//           }}
//         >
//           <KTIcon iconName='plus-circle' className='fs-3' />
//           Circle
//         </button>
//         <button
//           onClick={() => {
//             setDrawingMode('polygon')
//             setPolygonPoints([])
//             alert('Click on the map to add polygon points. Use Finish button when done.')
//           }}
//           className={`btn ${drawingMode === 'polygon' ? 'btn-primary' : 'btn-light'} shadow-sm`}
//           style={{
//             borderRadius: '8px',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '8px',
//           }}
//         >
//           <KTIcon iconName='abstract-26' className='fs-3' />
//           Polygon
//         </button>
//         <button
//           onClick={() => setShowRestrictionSettings(!showRestrictionSettings)}
//           className='btn btn-light shadow-sm'
//           style={{
//             borderRadius: '8px',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '8px',
//           }}
//         >
//           <KTIcon iconName='shield-tick' className='fs-3' />
//           Restrictions
//         </button>
//       </div>

//       {/* Polygon Drawing Controls */}
//       {drawingMode === 'polygon' && (
//         <div
//           className='card shadow-sm'
//           style={{
//             position: 'absolute',
//             top: '80px',
//             right: '20px',
//             zIndex: 999,
//             borderRadius: '8px',
//             background: 'rgba(255, 255, 255, 0.95)',
//           }}
//         >
//           <div className='card-body p-3'>
//             <h6 className='mb-3'>Drawing Polygon</h6>
//             <div className='text-muted small mb-3'>
//               Points: {polygonPoints.length}
//               {polygonPoints.length < 3 && <span className='text-danger'> (min 3 required)</span>}
//             </div>
//             <div className='d-flex gap-2'>
//               <button
//                 onClick={finishPolygonDrawing}
//                 className='btn btn-sm btn-success'
//                 disabled={polygonPoints.length < 3}
//               >
//                 <KTIcon iconName='check' className='fs-4' />
//                 Finish
//               </button>
//               <button onClick={cancelPolygonDrawing} className='btn btn-sm btn-light'>
//                 <KTIcon iconName='cross' className='fs-4' />
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Location Restriction Settings */}
//       {showRestrictionSettings && (
//         <div
//           className='card shadow-sm'
//           style={{
//             position: 'absolute',
//             top: '80px',
//             right: '20px',
//             zIndex: 999,
//             maxWidth: '300px',
//             borderRadius: '8px',
//             background: 'rgba(255, 255, 255, 0.95)',
//           }}
//         >
//           <div className='card-body p-3'>
//             <div className='d-flex justify-content-between align-items-center mb-3'>
//               <h6 className='mb-0'>Location Restrictions</h6>
//               <button
//                 onClick={() => setShowRestrictionSettings(false)}
//                 className='btn btn-sm btn-icon btn-light'
//               >
//                 <KTIcon iconName='cross' className='fs-4' />
//               </button>
//             </div>
//             <div className='form-check mb-2'>
//               <input
//                 className='form-check-input'
//                 type='radio'
//                 name='restriction'
//                 id='restriction-none'
//                 checked={locationRestriction === 'none'}
//                 onChange={() => setLocationRestriction('none')}
//               />
//               <label className='form-check-label' htmlFor='restriction-none'>
//                 No Restrictions
//               </label>
//             </div>
//             <div className='form-check mb-2'>
//               <input
//                 className='form-check-input'
//                 type='radio'
//                 name='restriction'
//                 id='restriction-inside'
//                 checked={locationRestriction === 'inside'}
//                 onChange={() => setLocationRestriction('inside')}
//                 disabled={geofences.length === 0}
//               />
//               <label className='form-check-label' htmlFor='restriction-inside'>
//                 Only Inside Geofences
//               </label>
//             </div>
//             <div className='form-check'>
//               <input
//                 className='form-check-input'
//                 type='radio'
//                 name='restriction'
//                 id='restriction-outside'
//                 checked={locationRestriction === 'outside'}
//                 onChange={() => setLocationRestriction('outside')}
//                 disabled={geofences.length === 0}
//               />
//               <label className='form-check-label' htmlFor='restriction-outside'>
//                 Only Outside Geofences
//               </label>
//             </div>
//             {geofences.length === 0 && (
//               <div className='alert alert-light mt-3 mb-0 p-2'>
//                 <small className='text-muted'>Create geofences to enable restrictions</small>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Geofence List */}
//       {geofences.length > 0 && !showRestrictionSettings && drawingMode !== 'polygon' && (
//         <div
//           className='card shadow-sm'
//           style={{
//             position: 'absolute',
//             top: '80px',
//             right: '20px',
//             zIndex: 999,
//             maxWidth: '300px',
//             maxHeight: '400px',
//             overflowY: 'auto',
//             borderRadius: '8px',
//             background: 'rgba(255, 255, 255, 0.95)',
//           }}
//         >
//           <div className='card-body p-3'>
//             <h6 className='card-title mb-3'>Geofences ({geofences.length})</h6>
//             <div className='d-flex flex-column gap-2'>
//               {geofences.map((gf) => (
//                 <div
//                   key={gf.id}
//                   className='d-flex justify-content-between align-items-center p-2 border rounded'
//                   style={{background: '#f8f9fa'}}
//                 >
//                   <div>
//                     <div className='fw-semibold'>{gf.name}</div>
//                     <div className='text-muted small'>
//                       {gf.type === 'circle' ? `Radius: ${gf.radius}m` : 'Polygon'}
//                     </div>
//                   </div>
//                   <button
//                     onClick={() => deleteGeofence(gf.id)}
//                     className='btn btn-sm btn-icon btn-light-danger'
//                   >
//                     <KTIcon iconName='trash' className='fs-4' />
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Selected Location Info */}
//       {selectedLocation && (
//         <div
//           className='card shadow-sm'
//           style={{
//             position: 'absolute',
//             bottom: '20px',
//             left: '20px',
//             zIndex: 999,
//             maxWidth: '350px',
//             borderRadius: '8px',
//             background: 'rgba(255, 255, 255, 0.95)',
//           }}
//         >
//           <div className='card-body p-4'>
//             <div className='d-flex justify-content-between align-items-start mb-2'>
//               <h5 className='card-title mb-0'>Selected Location</h5>
//               <button
//                 onClick={() => setSelectedLocation(null)}
//                 className='btn btn-sm btn-icon btn-light'
//                 style={{padding: '4px'}}
//               >
//                 <KTIcon iconName='cross' className='fs-3' />
//               </button>
//             </div>
//             <div className='text-gray-700'>
//               <div className='d-flex align-items-start mb-2'>
//                 <KTIcon iconName='geolocation' className='fs-4 me-2 text-primary' />
//                 <span className='fw-semibold'>{selectedLocation.placeName}</span>
//               </div>
//               {selectedLocation.address && (
//                 <div className='text-muted small mb-2'>{selectedLocation.address}</div>
//               )}
//               <div className='text-muted small'>
//                 <div>Lat: {selectedLocation.latitude.toFixed(6)}</div>
//                 <div>Lng: {selectedLocation.longitude.toFixed(6)}</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Geofence Modal */}
//       {showGeofenceModal && (
//         <>
//           <div
//             className='modal fade show d-block'
//             tabIndex='-1'
//             style={{background: 'rgba(0,0,0,0.5)'}}
//           >
//             <div className='modal-dialog modal-dialog-centered'>
//               <div className='modal-content'>
//                 <div className='modal-header'>
//                   <h5 className='modal-title'>
//                     Create {currentGeofence?.type === 'circle' ? 'Circular' : 'Polygon'} Geofence
//                   </h5>
//                   <button
//                     type='button'
//                     className='btn-close'
//                     onClick={() => {
//                       setShowGeofenceModal(false)
//                       setCurrentGeofence(null)
//                       setPolygonPoints([])
//                     }}
//                   ></button>
//                 </div>
//                 <div className='modal-body'>
//                   <div className='mb-4'>
//                     <label className='form-label fw-semibold'>Geofence Name</label>
//                     <input
//                       type='text'
//                       className='form-control'
//                       placeholder='e.g., Office Area, Delivery Zone'
//                       value={geofenceName}
//                       onChange={(e) => setGeofenceName(e.target.value)}
//                     />
//                   </div>
//                   {currentGeofence?.type === 'circle' && (
//                     <div className='mb-4'>
//                       <label className='form-label fw-semibold'>Radius (meters)</label>
//                       <input
//                         type='number'
//                         className='form-control'
//                         value={geofenceRadius}
//                         onChange={(e) => {
//                           setGeofenceRadius(Number(e.target.value))
//                           if (currentGeofence) {
//                             setCurrentGeofence({
//                               ...currentGeofence,
//                               radius: Number(e.target.value),
//                             })
//                           }
//                         }}
//                         min='50'
//                         max='10000'
//                       />
//                       <div className='form-text'>Set the radius (50-10000m)</div>
//                     </div>
//                   )}
//                   {currentGeofence && (
//                     <div className='alert alert-light'>
//                       <div className='text-muted small'>
//                         {currentGeofence.type === 'circle' ? (
//                           <div>
//                             Center: {currentGeofence.center[1].toFixed(6)},{' '}
//                             {currentGeofence.center[0].toFixed(6)}
//                           </div>
//                         ) : (
//                           <div>Polygon with {currentGeofence.coordinates.length - 1} points</div>
//                         )}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className='modal-footer'>
//                   <button
//                     type='button'
//                     className='btn btn-light'
//                     onClick={() => {
//                       setShowGeofenceModal(false)
//                       setCurrentGeofence(null)
//                       setPolygonPoints([])
//                     }}
//                   >
//                     Cancel
//                   </button>
//                   <button type='button' className='btn btn-primary' onClick={saveGeofence}>
//                     Create Geofence
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       {/* Full Width Map */}
//       <Map
//         ref={mapRef}
//         mapLib={maplibregl}
//         mapStyle='https://api.maptiler.com/maps/streets-v2/style.json?key=LiH20XNxcFiTXyT4fgjM'
//         center={
//           searchResult
//             ? [searchResult.longitude, searchResult.latitude]
//             : [-0.481747846041145, 51.3233379650232]
//         }
//         onClick={handleMapClick}
//         style={{
//           width: '100%',
//           height: '100%',
//           borderRadius: 0,
//           cursor: drawingMode ? 'crosshair' : 'default',
//         }}
//       >
//         {searchResult && (
//           <Marker
//             latitude={searchResult.latitude}
//             longitude={searchResult.longitude}
//             offsetLeft={-15}
//             offsetTop={-15}
//           >
//             <KTIcon iconName='geolocation' className='fs-2 text-danger fw-semibold' />
//           </Marker>
//         )}

//         {/* Render Temporary Polygon Drawing */}
//         {temporaryPointsGeoJSON && (
//           <Source id='temp-points' type='geojson' data={temporaryPointsGeoJSON}>
//             <Layer
//               id='temp-points-layer'
//               type='circle'
//               paint={{
//                 'circle-radius': 6,
//                 'circle-color': '#ef4444',
//                 'circle-stroke-width': 2,
//                 'circle-stroke-color': '#ffffff',
//               }}
//             />
//           </Source>
//         )}

//         {temporaryPolygonGeoJSON && (
//           <Source id='temp-polygon' type='geojson' data={temporaryPolygonGeoJSON}>
//             <Layer
//               id='temp-polygon-layer'
//               type='line'
//               paint={{
//                 'line-color': '#ef4444',
//                 'line-width': 2,
//                 'line-dasharray': [2, 2],
//               }}
//             />
//           </Source>
//         )}

//         {/* Render Geofences */}
//         {geofences.map((gf) => (
//           <Source
//             key={`geofence-${gf.id}`}
//             id={`geofence-${gf.id}`}
//             type='geojson'
//             data={gf.geoJSON}
//           >
//             <Layer
//               id={`geofence-fill-${gf.id}`}
//               type='fill'
//               paint={{
//                 'fill-color': '#10b981',
//                 'fill-opacity': 0.2,
//               }}
//             />
//             <Layer
//               id={`geofence-outline-${gf.id}`}
//               type='line'
//               paint={{
//                 'line-color': '#10b981',
//                 'line-width': 3,
//               }}
//             />
//           </Source>
//         ))}

//         {/* Render KML Data */}
//         {kmlData && (
//           <>
//             <Source id='kml-source' type='geojson' data={kmlData}>
//               <Layer
//                 id='kml-points'
//                 type='circle'
//                 filter={['==', ['geometry-type'], 'Point']}
//                 paint={{
//                   'circle-radius': 8,
//                   'circle-color': '#3b82f6',
//                   'circle-stroke-width': 2,
//                   'circle-stroke-color': '#ffffff',
//                 }}
//               />
//               <Layer
//                 id='kml-lines'
//                 type='line'
//                 filter={['==', ['geometry-type'], 'LineString']}
//                 paint={{
//                   'line-color': '#3b82f6',
//                   'line-width': 3,
//                 }}
//               />
//               <Layer
//                 id='kml-polygons-fill'
//                 type='fill'
//                 filter={['==', ['geometry-type'], 'Polygon']}
//                 paint={{
//                   'fill-color': '#3b82f6',
//                   'fill-opacity': 0.3,
//                 }}
//               />
//               <Layer
//                 id='kml-polygons-outline'
//                 type='line'
//                 filter={['==', ['geometry-type'], 'Polygon']}
//                 paint={{
//                   'line-color': '#3b82f6',
//                   'line-width': 2,
//                 }}
//               />
//             </Source>
//           </>
//         )}
//       </Map>
//     </div>
//   )
// }

import Map, {Marker, Source, Layer} from 'react-map-gl'
import maplibregl from 'maplibre-gl'
import 'maplibre-gl/dist/maplibre-gl.css'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import {useEffect, useRef, useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import './index.css'

export default function MapComponent({updateItemId}) {
  const mapRef = useRef(null)
  const fileInputRef = useRef(null)
  const [searchQuery, setSearchQuery] = useState('')
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [suggestions, setSuggestions] = useState([])
  const [searchResult, setSearchResult] = useState(null)
  const [selectedLocation, setSelectedLocation] = useState(null)
  const [kmlData, setKmlData] = useState(null)
  const [showGeofenceModal, setShowGeofenceModal] = useState(false)
  const [geofences, setGeofences] = useState([])
  const [drawingMode, setDrawingMode] = useState(null)
  const [currentGeofence, setCurrentGeofence] = useState(null)
  const [geofenceName, setGeofenceName] = useState('')
  const [geofenceRadius, setGeofenceRadius] = useState(500)
  const [polygonPoints, setPolygonPoints] = useState([])
  const [geofenceMode, setGeofenceMode] = useState('restricted') // 'allowed' or 'restricted'

  const accessToken =
    'pk.eyJ1IjoiZ2FuZXN3YXJhcmFvIiwiYSI6ImNsdHBpeXJtZjA2eWkya28xcW8xbjg4dXcifQ.2NgizzxlIv7hziFTq6JmgQ'

  // ======================
  // Utility Functions
  // ======================

  const isPointInPolygon = (point, polygon) => {
    const x = point[0],
      y = point[1]
    let inside = false
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0],
        yi = polygon[i][1]
      const xj = polygon[j][0],
        yj = polygon[j][1]
      const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
      if (intersect) inside = !inside
    }
    return inside
  }

  const isPointInCircle = (point, center, radiusInMeters) => {
    const [x1, y1] = point
    const [x2, y2] = center
    const dx = (x1 - x2) * 111320 * Math.cos((y2 * Math.PI) / 180)
    const dy = (y1 - y2) * 110574
    const distance = Math.sqrt(dx * dx + dy * dy)
    return distance <= radiusInMeters
  }

  const isLocationAllowed = (lng, lat) => {
    if (geofences.length === 0) return true

    const point = [lng, lat]

    // If inside ANY allowed geofence → allowed
    const isInsideAllowed = geofences.some(
      (gf) =>
        gf.mode === 'allowed' &&
        ((gf.type === 'circle' && isPointInCircle(point, gf.center, gf.radius)) ||
          (gf.type === 'polygon' && isPointInPolygon(point, gf.coordinates)))
    )

    if (isInsideAllowed) return true

    // If inside ANY restricted geofence → disallowed
    const isInsideRestricted = geofences.some(
      (gf) =>
        gf.mode === 'restricted' &&
        ((gf.type === 'circle' && isPointInCircle(point, gf.center, gf.radius)) ||
          (gf.type === 'polygon' && isPointInPolygon(point, gf.coordinates)))
    )

    return !isInsideRestricted
  }

  // ======================
  // Event Handlers
  // ======================

  const handleSearch = async () => {
    if (!searchQuery.trim()) return
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
          searchQuery
        )}.json?access_token=${accessToken}`
      )
      const data = await response.json()
      if (data.features && data.features.length > 0) {
        const [longitude, latitude] = data.features[0].center
        if (!isLocationAllowed(longitude, latitude)) {
          alert('Location selection is restricted in this area.')
          return
        }
        setSearchResult({longitude, latitude})
        updateItemId(data.features[0])
        mapRef.current.getMap().flyTo({center: [longitude, latitude], zoom: 12})
        setShowSuggestions(false)
      }
    } catch (error) {
      console.error('Error fetching coordinates:', error)
    }
  }

  const handleMapClick = async (event) => {
    const {lngLat} = event

    // Polygon drawing mode
    if (drawingMode === 'polygon') {
      const newPoint = [lngLat.lng, lngLat.lat]
      setPolygonPoints([...polygonPoints, newPoint])
      return
    }

    // Circle drawing mode
    if (drawingMode === 'circle') {
      setCurrentGeofence({
        type: 'circle',
        center: [lngLat.lng, lngLat.lat],
        radius: geofenceRadius,
      })
      setShowGeofenceModal(true)
      setDrawingMode(null)
      return
    }

    // Regular click: check restriction
    if (!isLocationAllowed(lngLat.lng, lngLat.lat)) {
      alert('Location selection is restricted in this area.')
      return
    }

    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lngLat.lng},${lngLat.lat}.json?access_token=${accessToken}`
      )
      const data = await response.json()
      if (data.features && data.features.length > 0) {
        const [longitude, latitude] = data.features[0].center
        const locationData = {
          longitude,
          latitude,
          placeName: data.features[0].place_name,
          address: data.features[0].properties?.address || '',
        }
        setSelectedLocation(locationData)
        setSearchResult({longitude, latitude})
        updateItemId(data.features[0])
      } else {
        setSelectedLocation({
          longitude: lngLat.lng,
          latitude: lngLat.lat,
          placeName: `${lngLat.lat.toFixed(6)}, ${lngLat.lng.toFixed(6)}`,
          address: '',
        })
        setSearchResult({longitude: lngLat.lng, latitude: lngLat.lat})
      }
    } catch (error) {
      console.error('Error fetching location details:', error)
    }
  }

  const finishPolygonDrawing = () => {
    if (polygonPoints.length < 3) {
      alert('Please add at least 3 points to create a polygon')
      return
    }
    setCurrentGeofence({
      type: 'polygon',
      coordinates: [...polygonPoints, polygonPoints[0]],
    })
    setShowGeofenceModal(true)
    setDrawingMode(null)
  }

  const cancelPolygonDrawing = () => {
    setPolygonPoints([])
    setDrawingMode(null)
  }

  // ======================
  // GeoJSON Helpers
  // ======================

  const createCircleGeoJSON = (center, radiusInMeters) => {
    const points = 64
    const coords = []
    const distanceX = radiusInMeters / (111320 * Math.cos((center[1] * Math.PI) / 180))
    const distanceY = radiusInMeters / 110574
    for (let i = 0; i < points; i++) {
      const theta = (i / points) * (2 * Math.PI)
      const x = distanceX * Math.cos(theta)
      const y = distanceY * Math.sin(theta)
      coords.push([center[0] + x, center[1] + y])
    }
    coords.push(coords[0])
    return {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Polygon',
        coordinates: [coords],
      },
    }
  }

  const createPolygonGeoJSON = (coordinates) => {
    return {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Polygon',
        coordinates: [coordinates],
      },
    }
  }

  // ======================
  // Geofence Management
  // ======================

  const saveGeofence = () => {
    if (!geofenceName.trim() || !currentGeofence) {
      alert('Please enter a geofence name')
      return
    }
    const newGeofence = {
      id: Date.now(),
      name: geofenceName,
      mode: geofenceMode,
      type: currentGeofence.type,
      ...(currentGeofence.type === 'circle'
        ? {
            center: currentGeofence.center,
            radius: currentGeofence.radius,
            geoJSON: createCircleGeoJSON(currentGeofence.center, currentGeofence.radius),
          }
        : {
            coordinates: currentGeofence.coordinates,
            geoJSON: createPolygonGeoJSON(currentGeofence.coordinates),
          }),
    }
    setGeofences([...geofences, newGeofence])
    setShowGeofenceModal(false)
    setGeofenceName('')
    setCurrentGeofence(null)
    setPolygonPoints([])
    setGeofenceMode('restricted') // reset to default
  }

  const deleteGeofence = (id) => {
    setGeofences(geofences.filter((gf) => gf.id !== id))
  }

  // ======================
  // KML Handling
  // ======================

  const parseKMLToGeoJSON = (kmlText) => {
    const parser = new DOMParser()
    const xmlDoc = parser.parseFromString(kmlText, 'text/xml')
    const features = []
    const placemarks = xmlDoc.getElementsByTagName('Placemark')
    for (let i = 0; i < placemarks.length; i++) {
      const placemark = placemarks[i]
      const name = placemark.getElementsByTagName('name')[0]?.textContent || `Feature ${i + 1}`
      const point = placemark.getElementsByTagName('Point')[0]
      if (point) {
        const coordinates = point.getElementsByTagName('coordinates')[0]?.textContent.trim()
        if (coordinates) {
          const [lng, lat] = coordinates.split(',').map(Number)
          features.push({
            type: 'Feature',
            properties: {name},
            geometry: {
              type: 'Point',
              coordinates: [lng, lat],
            },
          })
        }
      }
      const lineString = placemark.getElementsByTagName('LineString')[0]
      if (lineString) {
        const coordinates = lineString.getElementsByTagName('coordinates')[0]?.textContent.trim()
        if (coordinates) {
          const coords = coordinates.split(/\s+/).map((coord) => {
            const [lng, lat] = coord.split(',').map(Number)
            return [lng, lat]
          })
          features.push({
            type: 'Feature',
            properties: {name},
            geometry: {
              type: 'LineString',
              coordinates: coords,
            },
          })
        }
      }
      const polygon = placemark.getElementsByTagName('Polygon')[0]
      if (polygon) {
        const outerBoundary = polygon.getElementsByTagName('outerBoundaryIs')[0]
        if (outerBoundary) {
          const coordinates = outerBoundary
            .getElementsByTagName('coordinates')[0]
            ?.textContent.trim()
          if (coordinates) {
            const coords = coordinates.split(/\s+/).map((coord) => {
              const [lng, lat] = coord.split(',').map(Number)
              return [lng, lat]
            })
            features.push({
              type: 'Feature',
              properties: {name},
              geometry: {
                type: 'Polygon',
                coordinates: [coords],
              },
            })
          }
        }
      }
    }
    return {
      type: 'FeatureCollection',
      features,
    }
  }

  const handleKMLUpload = (event) => {
    const file = event.target.files[0]
    if (!file) return
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        const kmlText = e.target.result
        const geoJSON = parseKMLToGeoJSON(kmlText)
        if (geoJSON.features.length > 0) {
          setKmlData(geoJSON)
          const coordinates = []
          geoJSON.features.forEach((feature) => {
            if (feature.geometry.type === 'Point') {
              coordinates.push(feature.geometry.coordinates)
            } else if (feature.geometry.type === 'LineString') {
              coordinates.push(...feature.geometry.coordinates)
            } else if (feature.geometry.type === 'Polygon') {
              coordinates.push(...feature.geometry.coordinates[0])
            }
          })
          if (coordinates.length > 0) {
            const lngs = coordinates.map((c) => c[0])
            const lats = coordinates.map((c) => c[1])
            const bounds = [
              [Math.min(...lngs), Math.min(...lats)],
              [Math.max(...lngs), Math.max(...lats)],
            ]
            mapRef.current.getMap().fitBounds(bounds, {padding: 50})
          }
        } else {
          alert('No valid features found in KML file')
        }
      } catch (error) {
        console.error('Error parsing KML:', error)
        alert('Error parsing KML file. Please ensure it is a valid KML file.')
      }
    }
    reader.readAsText(file)
  }

  // ======================
  // Suggestions
  // ======================

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!searchQuery.trim()) {
        setSuggestions([])
        return
      }
      try {
        const response = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
            searchQuery
          )}.json?access_token=${accessToken}`
        )
        const data = await response.json()
        setSuggestions(data.features ? data.features.map((f) => f.place_name) : [])
      } catch (error) {
        console.error('Error fetching suggestions:', error)
        setSuggestions([])
      }
    }
    fetchSuggestions()
  }, [searchQuery])

  // ======================
  // Temporary Drawing Layers
  // ======================

  const temporaryPolygonGeoJSON =
    polygonPoints.length >= 2
      ? {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: polygonPoints,
              },
            },
          ],
        }
      : null

  const temporaryPointsGeoJSON =
    polygonPoints.length > 0
      ? {
          type: 'FeatureCollection',
          features: polygonPoints.map((point, i) => ({
            type: 'Feature',
            properties: {index: i},
            geometry: {
              type: 'Point',
              coordinates: point,
            },
          })),
        }
      : null

  const [editingGeofence, setEditingGeofence] = useState(null)
  const [editGeofenceName, setEditGeofenceName] = useState('')
  const [editGeofenceMode, setEditGeofenceMode] = useState('restricted')

  // ======================
  // Render
  // ======================

  return (
    <div className='map-container'>
      {/* Left Sidebar */}
      <div className='card map-sidebar'>
        {/* Search Section */}
        <div style={{padding: '20px', borderBottom: '1px solid #e5e7eb'}}>
          <h4 className='mb-3 fw-semibold'>Search Location</h4>
          <div className='position-relative'>
            <KTIcon
              iconName='magnifier'
              className='fs-3 position-absolute ms-3 mt-4 text-gray-600'
            />
            <input
              type='search'
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value)
                setShowSuggestions(true)
              }}
              placeholder='Search location...'
              className='form-control form-control-lg ps-10'
              style={{borderRadius: '8px'}}
            />
          </div>
          {showSuggestions && suggestions.length > 0 && (
            <div
              className='card mt-2 shadow-sm'
              style={{
                maxHeight: '200px',
                overflowY: 'auto',
                borderRadius: '8px',
              }}
            >
              {suggestions.map((name, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setSearchQuery(name)
                    handleSearch()
                  }}
                  style={{
                    padding: '10px 15px',
                    cursor: 'pointer',
                    borderBottom: index < suggestions.length - 1 ? '1px solid #f1f1f1' : 'none',
                  }}
                  className='text-hover-primary'
                >
                  <small>{name}</small>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Controls Section */}
        <div style={{padding: '20px', borderBottom: '1px solid #e5e7eb'}}>
          <h4 className='mb-3 fw-semibold'>Drawing Tools</h4>
          <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
            <input
              ref={fileInputRef}
              type='file'
              accept='.kml'
              onChange={handleKMLUpload}
              style={{display: 'none'}}
            />
            <button
              onClick={() => fileInputRef.current?.click()}
              className='btn btn-light w-100 d-flex align-items-center justify-content-start gap-2'
              style={{borderRadius: '8px'}}
            >
              <KTIcon iconName='file-up' className='fs-3' />
              <span>Upload KML File</span>
            </button>
            <button
              onClick={() => {
                setDrawingMode('circle')
                alert('Click on the map to place a circular geofence')
              }}
              className={`btn ${
                drawingMode === 'circle' ? 'btn-primary' : 'btn-light'
              } w-100 d-flex align-items-center justify-content-start gap-2`}
              style={{borderRadius: '8px'}}
            >
              <KTIcon iconName='plus-circle' className='fs-3' />
              <span>Draw Circle</span>
            </button>
            <button
              onClick={() => {
                setDrawingMode('polygon')
                setPolygonPoints([])
                alert('Click on the map to add polygon points. Use Finish button when done.')
              }}
              className={`btn ${
                drawingMode === 'polygon' ? 'btn-primary' : 'btn-light'
              } w-100 d-flex align-items-center justify-content-start gap-2`}
              style={{borderRadius: '8px'}}
            >
              <KTIcon iconName='abstract-26' className='fs-3' />
              <span>Draw Polygon</span>
            </button>
          </div>
        </div>

        {/* Polygon Drawing Controls */}
        {drawingMode === 'polygon' && (
          <div style={{padding: '20px', background: '#fef3c7', borderBottom: '1px solid #fde047'}}>
            <h6 className='mb-2 fw-bold text-warning'>Drawing Mode Active</h6>
            <p className='text-muted small mb-3'>
              Points: {polygonPoints.length}
              {polygonPoints.length < 3 && <span className='text-danger'> (min 3 required)</span>}
            </p>
            <div className='d-flex gap-2'>
              <button
                onClick={finishPolygonDrawing}
                className='btn btn-sm btn-success flex-grow-1'
                disabled={polygonPoints.length < 3}
              >
                <KTIcon iconName='check' className='fs-4' />
                Finish
              </button>
              <button onClick={cancelPolygonDrawing} className='btn btn-sm btn-light'>
                <KTIcon iconName='cross' className='fs-4' />
                Cancel
              </button>
            </div>
          </div>
        )}

        {/* Geofences List */}
        <div style={{flex: 1, overflowY: 'auto', padding: '20px'}}>
          <h4 className='mb-3 fw-semibold'>Geofences ({geofences.length})</h4>
          {geofences.length === 0 ? (
            <div className='text-center text-muted py-4'>
              <KTIcon iconName='map' className='fs-2x mb-2' />
              <p className='small mb-0'>No geofences created yet</p>
            </div>
          ) : (
            <div className='d-flex flex-column gap-2'>
              {geofences.map((gf) => (
                <div
                  key={gf.id}
                  className='card shadow-sm'
                  style={{borderRadius: '8px', border: '1px solid #e5e7eb', cursor: 'pointer'}}
                  onClick={() => {
                    setEditingGeofence(gf)
                    setEditGeofenceName(gf.name)
                    setEditGeofenceMode(gf.mode || 'restricted')
                  }}
                >
                  <div className='card-body p-3'>
                    <div className='d-flex justify-content-between align-items-start'>
                      <div className='flex-grow-1'>
                        <div className='fw-bold mb-1'>{gf.name}</div>
                        <div className='d-flex align-items-center gap-2 text-muted small'>
                          <KTIcon
                            iconName={gf.type === 'circle' ? 'plus-circle' : 'abstract-26'}
                            className='fs-5'
                          />
                          <span>{gf.type === 'circle' ? `${gf.radius}m radius` : 'Polygon'}</span>
                          <span
                            className={`badge ms-2 ${
                              gf.mode === 'allowed' ? 'badge-success' : 'badge-danger'
                            }`}
                          >
                            {gf.mode === 'allowed' ? 'Allowed' : 'Restricted'}
                          </span>
                        </div>
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation()
                          deleteGeofence(gf.id)
                        }}
                        className='btn btn-sm btn-icon btn-light-danger'
                        style={{width: '32px', height: '32px'}}
                      >
                        <KTIcon iconName='trash' className='fs-5' />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Map Container */}
      <div className='map-main'>
        {/* Selected Location Info */}
        {selectedLocation && (
          <div
            className='card shadow-lg'
            style={{
              position: 'absolute',
              bottom: '20px',
              left: '20px',
              right: '20px',
              zIndex: 999,
              maxWidth: '400px',
              borderRadius: '12px',
              background: '#fff',
            }}
          >
            <div className='card-body p-4'>
              <div className='d-flex justify-content-between align-items-start mb-3'>
                <h5 className='card-title mb-0 fw-bold'>Selected Location</h5>
                <button
                  onClick={() => setSelectedLocation(null)}
                  className='btn btn-sm btn-icon btn-light'
                  style={{width: '32px', height: '32px'}}
                >
                  <KTIcon iconName='cross' className='fs-4' />
                </button>
              </div>
              <div className='text-gray-700'>
                <div className='d-flex align-items-start mb-3 p-3 bg-light rounded'>
                  <KTIcon iconName='geolocation' className='fs-3 me-3 text-primary' />
                  <div>
                    <div className='fw-semibold mb-1'>{selectedLocation.placeName}</div>
                    {selectedLocation.address && (
                      <div className='text-muted small'>{selectedLocation.address}</div>
                    )}
                  </div>
                </div>
                <div className='d-flex gap-4'>
                  <div>
                    <div className='text-muted small'>Latitude</div>
                    <div className='fw-semibold'>{selectedLocation.latitude.toFixed(6)}</div>
                  </div>
                  <div>
                    <div className='text-muted small'>Longitude</div>
                    <div className='fw-semibold'>{selectedLocation.longitude.toFixed(6)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Geofence Modal */}
        {showGeofenceModal && (
          <div
            className='modal fade show d-block'
            tabIndex='-1'
            style={{background: 'rgba(0,0,0,0.5)', zIndex: 10000}}
          >
            <div className='modal-dialog modal-dialog-centered'>
              <div className='modal-content' style={{borderRadius: '12px'}}>
                <div className='modal-header border-0 pb-0'>
                  <h5 className='modal-title fw-bold'>
                    Create {currentGeofence?.type === 'circle' ? 'Circular' : 'Polygon'} Geofence
                  </h5>
                  <button
                    type='button'
                    className='btn-close'
                    onClick={() => {
                      setShowGeofenceModal(false)
                      setCurrentGeofence(null)
                      setPolygonPoints([])
                    }}
                  ></button>
                </div>
                <div className='modal-body pt-3'>
                  <div className='mb-4'>
                    <label className='form-label fw-semibold'>Geofence Name</label>
                    <input
                      type='text'
                      className='form-control form-control-lg'
                      placeholder='e.g., Office Area, Delivery Zone'
                      value={geofenceName}
                      onChange={(e) => setGeofenceName(e.target.value)}
                      style={{borderRadius: '8px'}}
                    />
                  </div>

                  {/* Mode Toggle */}
                  <div className='mb-4'>
                    <label className='form-label fw-semibold'>Access Mode</label>
                    <div className='d-flex gap-4'>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='geofence-mode'
                          id='mode-allowed'
                          checked={geofenceMode === 'allowed'}
                          onChange={() => setGeofenceMode('allowed')}
                        />
                        <label className='form-check-label' htmlFor='mode-allowed'>
                          <span className='text-success fw-bold'>Allowed</span>
                        </label>
                      </div>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='geofence-mode'
                          id='mode-restricted'
                          checked={geofenceMode === 'restricted'}
                          onChange={() => setGeofenceMode('restricted')}
                        />
                        <label className='form-check-label' htmlFor='mode-restricted'>
                          <span className='text-danger fw-bold'>Restricted</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  {currentGeofence?.type === 'circle' && (
                    <div className='mb-4'>
                      <label className='form-label fw-semibold'>Radius (meters)</label>
                      <input
                        type='number'
                        className='form-control form-control-lg'
                        value={geofenceRadius}
                        onChange={(e) => {
                          setGeofenceRadius(Number(e.target.value))
                          if (currentGeofence) {
                            setCurrentGeofence({
                              ...currentGeofence,
                              radius: Number(e.target.value),
                            })
                          }
                        }}
                        min='50'
                        max='10000'
                        style={{borderRadius: '8px'}}
                      />
                      <div className='form-text'>Set the radius (50–10000m)</div>
                    </div>
                  )}

                  {currentGeofence && (
                    <div className='alert alert-light' style={{borderRadius: '8px'}}>
                      <div className='text-muted small'>
                        {currentGeofence.type === 'circle' ? (
                          <div>
                            <strong>Center:</strong> {currentGeofence.center[1].toFixed(6)},{' '}
                            {currentGeofence.center[0].toFixed(6)}
                          </div>
                        ) : (
                          <div>
                            <strong>Polygon:</strong> {currentGeofence.coordinates.length - 1}{' '}
                            points
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className='modal-footer border-0 pt-0'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setShowGeofenceModal(false)
                      setCurrentGeofence(null)
                      setPolygonPoints([])
                    }}
                    style={{borderRadius: '8px'}}
                  >
                    Cancel
                  </button>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={saveGeofence}
                    style={{borderRadius: '8px'}}
                  >
                    <KTIcon iconName='check' className='fs-4 me-2' />
                    Create Geofence
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Edit Geofence Modal */}
        {editingGeofence && (
          <div
            className='modal fade show d-block'
            tabIndex='-1'
            style={{background: 'rgba(0,0,0,0.5)', zIndex: 10000}}
          >
            <div className='modal-dialog modal-dialog-centered'>
              <div className='modal-content' style={{borderRadius: '12px'}}>
                <div className='modal-header border-0 pb-0'>
                  <h5 className='modal-title fw-bold'>Edit Geofence</h5>
                  <button
                    type='button'
                    className='btn-close'
                    onClick={() => {
                      setEditingGeofence(null)
                      setEditGeofenceName('')
                      setEditGeofenceMode('restricted')
                    }}
                  ></button>
                </div>
                <div className='modal-body pt-3'>
                  <div className='mb-4'>
                    <label className='form-label fw-semibold'>Geofence Name</label>
                    <input
                      type='text'
                      className='form-control form-control-lg'
                      value={editGeofenceName}
                      onChange={(e) => setEditGeofenceName(e.target.value)}
                      style={{borderRadius: '8px'}}
                    />
                  </div>

                  {/* Mode Toggle */}
                  <div className='mb-4'>
                    <label className='form-label fw-semibold'>Access Mode</label>
                    <div className='d-flex gap-4'>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='edit-mode'
                          id='edit-allowed'
                          checked={editGeofenceMode === 'allowed'}
                          onChange={() => setEditGeofenceMode('allowed')}
                        />
                        <label className='form-check-label' htmlFor='edit-allowed'>
                          <span className='text-success fw-bold'>Allowed</span>
                        </label>
                      </div>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='edit-mode'
                          id='edit-restricted'
                          checked={editGeofenceMode === 'restricted'}
                          onChange={() => setEditGeofenceMode('restricted')}
                        />
                        <label className='form-check-label' htmlFor='edit-restricted'>
                          <span className='text-danger fw-bold'>Restricted</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='modal-footer border-0 pt-0'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setEditingGeofence(null)
                      setEditGeofenceName('')
                      setEditGeofenceMode('restricted')
                    }}
                    style={{borderRadius: '8px'}}
                  >
                    Cancel
                  </button>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => {
                      setGeofences((prev) =>
                        prev.map((gf) =>
                          gf.id === editingGeofence.id
                            ? {...gf, name: editGeofenceName, mode: editGeofenceMode}
                            : gf
                        )
                      )
                      setEditingGeofence(null)
                    }}
                    style={{borderRadius: '8px'}}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Map */}
        <Map
          ref={mapRef}
          mapLib={maplibregl}
          mapStyle='https://api.maptiler.com/maps/streets-v2/style.json?key=LiH20XNxcFiTXyT4fgjM'
          center={
            searchResult
              ? [searchResult.longitude, searchResult.latitude]
              : [-0.481747846041145, 51.3233379650232]
          }
          onClick={handleMapClick}
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '10px',
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
            cursor: drawingMode ? 'crosshair' : 'default',
          }}
        >
          {searchResult && (
            <Marker
              latitude={searchResult.latitude}
              longitude={searchResult.longitude}
              offsetLeft={-15}
              offsetTop={-15}
            >
              <KTIcon iconName='geolocation' className='fs-2 text-danger fw-semibold' />
            </Marker>
          )}

          {/* Temporary Drawing */}
          {temporaryPointsGeoJSON && (
            <Source id='temp-points' type='geojson' data={temporaryPointsGeoJSON}>
              <Layer
                id='temp-points-layer'
                type='circle'
                paint={{
                  'circle-radius': 6,
                  'circle-color': '#ef4444',
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#ffffff',
                }}
              />
            </Source>
          )}
          {temporaryPolygonGeoJSON && (
            <Source id='temp-polygon' type='geojson' data={temporaryPolygonGeoJSON}>
              <Layer
                id='temp-polygon-layer'
                type='line'
                paint={{
                  'line-color': '#ef4444',
                  'line-width': 2,
                  'line-dasharray': [2, 2],
                }}
              />
            </Source>
          )}

          {/* Render Geofences with color based on mode */}
          {geofences.map((gf) => {
            const fillColor = gf.mode === 'allowed' ? '#10b981' : '#ef4444'
            return (
              <Source
                key={`geofence-${gf.id}`}
                id={`geofence-${gf.id}`}
                type='geojson'
                data={gf.geoJSON}
              >
                <Layer
                  id={`geofence-fill-${gf.id}`}
                  type='fill'
                  paint={{
                    'fill-color': fillColor,
                    'fill-opacity': 0.25,
                  }}
                />
                <Layer
                  id={`geofence-outline-${gf.id}`}
                  type='line'
                  paint={{
                    'line-color': fillColor,
                    'line-width': 3,
                  }}
                />
              </Source>
            )
          })}

          {/* KML Data */}
          {kmlData && (
            <Source id='kml-source' type='geojson' data={kmlData}>
              <Layer
                id='kml-points'
                type='circle'
                filter={['==', ['geometry-type'], 'Point']}
                paint={{
                  'circle-radius': 8,
                  'circle-color': '#3b82f6',
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#ffffff',
                }}
              />
              <Layer
                id='kml-lines'
                type='line'
                filter={['==', ['geometry-type'], 'LineString']}
                paint={{
                  'line-color': '#3b82f6',
                  'line-width': 3,
                }}
              />
              <Layer
                id='kml-polygons-fill'
                type='fill'
                filter={['==', ['geometry-type'], 'Polygon']}
                paint={{
                  'fill-color': '#3b82f6',
                  'fill-opacity': 0.3,
                }}
              />
              <Layer
                id='kml-polygons-outline'
                type='line'
                filter={['==', ['geometry-type'], 'Polygon']}
                paint={{
                  'line-color': '#3b82f6',
                  'line-width': 2,
                }}
              />
            </Source>
          )}
        </Map>
      </div>
    </div>
  )
}
